import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import LoadingOverlay from "../../../shared/components/LoadingOverlay";
import testTemplateActionCreators from "../../store/test-templates/action-creators";
import './TestTemplateReports.scss';
import {withRouter} from "react-router-dom";

function mapStateToProps(state) {
  return {
    testTemplates: state.testTemplates.list,
    testTemplatesMap: state.testTemplates.map,
    testQuestionReports: state.testTemplates.testQuestionReports,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchTestTemplates() {
      return dispatch(testTemplateActionCreators.fetchTestTemplates());
    },
    fetchTestTemplateReports(testTemplateId) {
      return dispatch(testTemplateActionCreators.fetchTestTemplateReports(testTemplateId));
    },
  };
}

class TestTemplateReports extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
    }
  }

  get testTemplate() {
    let testTemplate = this.props.testTemplatesMap[this.state.selectedGuid];
    if (testTemplate) {
      testTemplate.attempts = testTemplate.attempts ? testTemplate.attempts.toString() : null;
      testTemplate.duration = testTemplate.duration ? testTemplate.duration.toString() : null;
      testTemplate.passing_score = testTemplate.passing_score ? testTemplate.passing_score.toString() : null;
      testTemplate.questions_displayed = testTemplate.questions_displayed ? testTemplate.questions_displayed.toString() : null;
    }

    return testTemplate;
  }

  get testTemplateReports() {
    return this.props.testQuestionReports;
  }

  componentDidMount() {
    this.setState({
      isLoading: true,
      selectedGuid: this.props.match.params.guid
    });

    this.props.fetchTestTemplates()
      .then(() => {
        this.props.fetchTestTemplateReports(this.testTemplate.id).then(() => {
          this.setState({
            isLoading: false
          });
        });
      })
      .catch(() => {
        this.setState({
          isLoading: false
        });
      })
  }

  getCorrectnesPercentage(question) {
    if (!question.correctAnswers && question.wrongAnswers) {
      return 0;
    }
    else if (!question.wrongAnswers && question.correctAnswers) {
      return 100;
    }
    else {
      const total = question.wrongAnswers + question.correctAnswers;
      return Math.round((question.correctAnswers / total) * 100);
    }
  }

  parseAnsweredNumber(number) {
    if (!number) {
        return 0;
    }

    return number;
  }

  render() {
    return (
      <LoadingOverlay isLoading={this.state.isLoading}>
        <div className="app-content-header">
          <h4 className="title">{this.testTemplate ? this.testTemplate.title : ''} Reports</h4>
        </div>
        <div className="test-template-reports app-content">
          <div className="test-templates-card">
            {this.testTemplate &&
              <Fragment>
                {this.testTemplateReports && this.testTemplateReports.map((question) => (
                    <div key={question.id} className="question">
                        <div className="question-title">
                            {question.title}
                        </div>
                        <div className="answers-report">
                            <div className="correct">
                              Correct: {this.parseAnsweredNumber(question.correctAnswers)}
                            </div>
                            <div className="wrong">
                              Wrong:  {this.parseAnsweredNumber(question.wrongAnswers)}
                            </div>
                            {!isNaN(this.getCorrectnesPercentage(question)) &&
                              <div className="correctness">
                                Percent Correct:  {this.getCorrectnesPercentage(question)}%
                              </div>
                            }
                        </div>
                    </div>
                ))}
              </Fragment>
            }
          </div>
        </div>

      </LoadingOverlay>
    );
  }
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(TestTemplateReports));
